import TypePersonInvoiceEnum from "../enum/type_person.enum";

const ValidateFiscalFormPatient = (form = {}) => {


    let statusValidation = false;
    let newValidations = {};

    const rfc = form.rfc_patient ?? "";
    const taxRegime = form.tax_regime_id_patient ?? 0;
    const cp = form.cp_patient ?? "";
    const email = form.email_patient ?? "";
    const businessName = form.business_name_patient ?? "";
    const typePerson = form.type_person_patient;
    const useCfdi = form.id_use_cdfi ?? 0;
    const useEmail = form.sendEmail_patient ?? false


    // * RFC
    let rfcValid = false;

    if (rfc.trim() !== "") {

        if (
            typePerson === TypePersonInvoiceEnum.FISICA &&
            rfc.length === 13
        ) {
            rfcValid = true;
        }

        if (
            typePerson === TypePersonInvoiceEnum.MORAL &&
            rfc.length === 12
        ) {
            rfcValid = true;
        }
    }

    newValidations.rfc_patient_valid = !rfcValid;

    if (!rfcValid) {
        statusValidation = true;
    }

    // * TAX REGIMEN
    const taxRegimeValid = taxRegime !== 0;

    newValidations.id_tax_regime_patient_valid = !taxRegimeValid;

    if (!taxRegimeValid) {
        statusValidation = true;
    }


    // *  USE CFDI
    const useCfdiValid = useCfdi !== 0
    newValidations.id_use_cdfi_valid = !useCfdiValid;


    if (!useCfdiValid) {
        statusValidation = true;
    }


    // * CP
    const cpValid = cp !== "" && cp !== 0;

    newValidations.cp_patient_valid = !cpValid;

    if (!cpValid) {
        statusValidation = true;
    }

    // * EMAIL
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    let emailValid = true;

    if (useEmail) {
        emailValid =
            email.trim() !== "" &&
            emailPattern.test(email);
    }

    newValidations.email_valid = !emailValid;

    if (!emailValid) {
        statusValidation = true;
    }


    // * REASON 
    const businessNameValid =
        businessName.trim() !== "";

    newValidations.business_name_patient_valid =
        !businessNameValid;

    if (!businessNameValid) {
        statusValidation = true;
    }

    return {
        statusValidation,
        newValidations
    };
};

export default ValidateFiscalFormPatient;